import { AddressDto } from '@/api';

export interface MegacardChoiceEvent {
  choice: MegacardChoice;
  address?: AddressDto;
}

export enum MegacardChoice {
  REJECT,
  WANT,
  HAVE,
}

export enum MegacardRequestState {
  NOT_SUBMITTED,
  LOADING,
  SUCCESS,
  NOT_FOUND,
  ERROR,
}
